import {Injectable, signal} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SelectedRowStateService {
  private _selectedRowId = signal<number | null>(null);
  public selectedRowId = this._selectedRowId.asReadonly();

  public handleRowClick(rowId: number, isEditModeActive: boolean): void {
    this.selectedRowId() === rowId ? this.deselectRow(isEditModeActive) : this.selectRow(rowId);
  }

  public resetSelectedRow(): void {
    this._selectedRowId.set(null);
  }

  private selectRow(rowId: number): void {
    this._selectedRowId.set(rowId);
  }

  private deselectRow(isEditModeActive: boolean): void {
    if (isEditModeActive) { return; }

    this._selectedRowId.set(null);
  }
}
